export enum IndicatorGroupStatus {
  Active = "active", //активный
  Removed = "removed", //удалён
}
